import { render, staticRenderFns } from "./View_Duels_Challenge.vue?vue&type=template&id=0408e3d6&scoped=true&"
import script from "./View_Duels_Challenge.vue?vue&type=script&lang=js&"
export * from "./View_Duels_Challenge.vue?vue&type=script&lang=js&"
import style0 from "./View_Duels_Challenge.vue?vue&type=style&index=0&id=0408e3d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0408e3d6",
  null
  
)

export default component.exports